import { render, staticRenderFns } from "./form-base.vue?vue&type=template&id=d08aaf84"
import script from "./form-base.vue?vue&type=script&lang=js"
export * from "./form-base.vue?vue&type=script&lang=js"
import style0 from "./form-base.vue?vue&type=style&index=0&id=d08aaf84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports